import React from 'react'

type BellNotificationProps = {
  notifiNumber: number
}

export function BellNotification({ notifiNumber }: BellNotificationProps) {
  return (
    <div>BellNotification</div>
  )
}